import { useContext } from 'react';
import { AssistantChatThreadContext } from '../contexts/assistantChatThreadContext';

export const useAssistantChatThreadContext = () => useContext(AssistantChatThreadContext);
